import React from "react";
import { useNavigate } from "react-router-dom";
import FleetrifyDumButton from "../../../Button";
import FleetrifyCard from "../../../Card";
import { motion, AnimatePresence } from "framer-motion";
import { getInitials } from "../../../../utils/helper";
import { FLEETRIFYROUTEPATH } from "../../../../routes/routesPath";

interface DriverOverviewDetailsProps {
  show?: boolean;
  drivers: any[];
  onNavigateCompany: () => void;
}

const DriverOverviewDetails: React.FC<DriverOverviewDetailsProps> = ({
  show,
  drivers,
  onNavigateCompany,
}) => {
  const navigate = useNavigate();

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ scale: 0.9, opacity: 0, height: 0 }}
          animate={{ scale: 1, opacity: 1, height: "auto" }}
          exit={{ scale: 0.95, opacity: 0, height: 0 }}
          transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
          className="w-full flex-1 h-full"
        >
          <FleetrifyCard cardContainerClass="overflow-hidden space-y-5 h-full">
            {/* Header */}
            <div className="flex justify-between items-center pb-5">
              <div>
                <h3 className="text-lg font-semibold text-[#00032A]">Drivers</h3>
                <p className="text-xs text-[#4F4F4F] italic">Drivers details</p>
              </div>
              <FleetrifyDumButton
                label="View More"
                onClick={() => navigate(FLEETRIFYROUTEPATH.USER)}
              />
            </div>

            {/* Driver List */}
            <div className="space-y-6 mt-5">
              {drivers?.length > 0 ? (
                drivers.map((trip: any, idx: number) => {
                  const driver = trip.driver_info || {};
                  return (
                    <div key={idx} className="flex justify-between items-center">
                      <div className="flex gap-4 items-center">
                        <div className="border-2 border-[#143887CC] h-8 w-8 rounded-full bg-[#F5F6FA] grid place-items-center text-primary font-medium">
                          {getInitials(driver.name)}
                        </div>
                        <div>
                          <p className="text-sm text-[#4F4F4F] font-medium">{driver.name}</p>
                          <p className="text-xs text-[#4F4F4F]">{trip.status}</p>
                        </div>
                      </div>
                      <p className="text-xs text-[#4F4F4F]">
                        {new Date(trip.date).toLocaleDateString()}
                      </p>
                    </div>
                  );
                })
              ) : (
                <div className="flex flex-col items-center justify-center gap-2 py-16">
                  <div className="text-4xl text-gray-300">📄</div>
                  <p className="text-sm text-gray-500 italic">No drivers found.</p>
                </div>
              )}
            </div>
          </FleetrifyCard>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DriverOverviewDetails;